import React, { useCallback } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapPin,
  faCheck,
  faTrashXmark,
} from '@fortawesome/pro-light-svg-icons';
import { AddressValue } from './Locations';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import Button from 'shared/design-system/components/TrueImpactButton';

type LocationSearchRowProps =
  | {
      loading: false;
      suggestion: AddressValue;
      index: number;
      handleAdd: (address: AddressValue) => unknown;
      handleRemove: (index: number) => unknown;
      selected: boolean;
      className?: string;
    }
  | {
      loading: true;
      suggestion?: undefined;
      index?: undefined;
      handleAdd?: undefined;
      handleRemove?: undefined;
      selected?: undefined;
      className?: string;
    };

const StyledDiv = styled.div`
  justify-content: space-between;
  padding: 4px 0;
  &,
  .left {
    display: flex;
    align-items: center;
  }
  .loading-bar {
    width: 200px;
    height: 12px;
    background: linear-gradient(90deg, #eaf0f6 0%, #f6f9fc 100%);
    border-radius: 24px;
  }
  .left {
    .pin-icon {
      padding-left: 5px;
      padding-right: 10px;
    }
  }
  .right {
    .added-button {
      color: ${COLORS.success};
      border-color: ${COLORS.success};
      .check-icon {
        display: inherit;
      }
      .trash-icon {
        display: none;
        margin-right: 1px;
      }
      &:hover {
        .check-icon {
          display: none;
        }
        .trash-icon {
          display: inherit;
        }
      }
    }
  }
`;

const LocationSearchRow: React.FC<LocationSearchRowProps> = ({
  handleAdd,
  handleRemove,
  loading,
  suggestion,
  selected,
  index,
  className,
}) => {
  const onAdd = useCallback(() => {
    suggestion && handleAdd(suggestion);
  }, [suggestion, handleAdd]);
  const onRemove = useCallback(() => {
    handleRemove?.(index);
  }, [index, handleRemove]);
  return (
    <StyledDiv className={className}>
      <div className="left">
        <FontAwesomeIcon
          icon={faMapPin}
          color={COLORS.ctaPrimary}
          className="pin-icon"
        />
        {loading ? (
          <div className="loading-bar"></div>
        ) : (
          <div>{suggestion.address || 'Unknown'}</div>
        )}
      </div>
      <div className="right">
        {!loading &&
          (selected ? (
            <Button
              variant="secondary-small"
              onClick={onRemove}
              className="added-button"
            >
              <FontAwesomeIcon icon={faCheck} className="check-icon" />
              <FontAwesomeIcon
                icon={faTrashXmark}
                color={COLORS.critical}
                className="trash-icon"
              />
              Added
            </Button>
          ) : (
            <Button variant="secondary-small" onClick={onAdd}>
              Add
            </Button>
          ))}
      </div>
    </StyledDiv>
  );
};

export default LocationSearchRow;
